export function navCloseMobile() {
  // Close mobile navbar when a link inside it is clicked
  const navButton = document.querySelector('.navbar-c .nav_menu-button');
  const navMenu = document.querySelector('.navbar-c .navbar-c_navigation');

  if (navButton && navMenu) {
    navMenu.addEventListener('click', (e) => {
      // Only real links — dropdown toggles are divs, so they're ignored
      const link = e.target.closest('a');
      if (!link) return;

      // Desktop: Webflow handles nav normally, nothing to do
      if (window.innerWidth >= 992) return;

      // Only close if menu is actually open
      if (!navButton.classList.contains('w--open')) return;

      // Triggers Webflow's native close (handles animation + state)
      navButton.click();
    });
  }
}
